<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-volume', fontSet: 'far'}"
	[headerText]="(data.editAnnouncement ? T.EDIT_ANNOUNCEMENT_DIALOG_HEADER : T.CREATE_ANNOUNCEMENT_DIALOG_HEADER) | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<div class="wrapper" dialogContent>
		<!--NAME-->
		<mat-form-field color="accent">
			<mat-label>{{ T.LABEL_NAME | translate }}</mat-label>
			<input [formControl]="form.controls.name" matInput />
			<mat-error>
				{{ T.ERROR_REQUIRED | translate }}
			</mat-error>
		</mat-form-field>

		<!--OFFSET TYPE-->
		<span>{{ T.PLAY_ANNOUNCEMENT_RELATIVE_TO | translate }}</span>
		<mat-radio-group [formControl]="form.controls.offsetType">
			<mat-radio-button [value]="ScheduledSoundOffsetType.FromStart"> {{ T.START_OF_PHASE_TIME | translate }}</mat-radio-button>
			<mat-radio-button [value]="ScheduledSoundOffsetType.FromEnd"> {{ T.END_OF_PHASE_TIME | translate }}</mat-radio-button>
		</mat-radio-group>
		<span class="secondary">
			{{
				form.controls.offsetType.value === ScheduledSoundOffsetType.FromStart
					? (T.PLAY_ANNOUNCEMENT_RELATIVE_TO_END | translate)
					: (T.PLAY_ANNOUNCEMENT_RELATIVE_TO_START | translate)
			}}
		</span>

		<!--TIME-->
		<fieldset class="timeInputWrapper">
			<sim-time-input [formCtrl]="form.controls.offset" [max]="data.duration" />

			<!--SLIDER-->
			<mat-slider
				[displayWith]="formatLabel()"
				[max]="data.duration"
				[step]="sliderStep"
				class="timeSlider"
				color="accent"
				discrete
				min="0"
				showTickMarks
			>
				<input
					(valueChange)="form.controls.offset.setValue($event)"
					[formControl]="form.controls.offset"
					[value]="form.controls.offset.value"
					matSliderThumb
				/>
			</mat-slider>

			<!--PHASE DURATION-->
			<label class="phaseDuration"> {{ data.duration | durationLabel }} {{ T.LABEL_MINUTES | translate }} </label>
		</fieldset>

		<!--FILE-->
		<sim-chip-autocomplete
			[dataType]="FetchDataType.Media"
			[formCtrl]="form.controls.media"
			[labelToken]="T.EXAM_FLOW_ANNOUNCEMENT_SELECT_FILE"
			[searchFilters]="[{searchColumn: 'MediaType', searchTerms: ['Audio']}]"
			subscriptSizing="dynamic"
		/>
	</div>
	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontIcon: 'fa-times', fontSet: 'far'}" [label]="T.BUTTON_CANCEL" color="warn" />
		<sim-button
			(onClick)="doSave()"
			[disabled]="form.invalid"
			[icon]="{fontIcon: 'fa-check', fontSet: 'far'}"
			[label]="T.BUTTON_SAVE"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
